export default function (activity) {
  if (activity.has('competition_instance')) {
    return {
      type: 'competition',
      permalink: activity.get('competition_instance').shared_key
    }
  } else if (activity.has('survey_instance')) {
    return {
      type: 'survey',
      permalink: activity.get('survey_instance').shared_key
    }
  }

  return null
}
